import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../styles/HeroSlider.scss';

const HeroSliderSkeleton = () => {
  return (
    <section className="hero-slider-section">
      <div className="slider-container">
        <div className="slides">
          <div className="slide">
            <Skeleton height={676} width="100%" />
          </div>
        </div>
        {/* Navigation buttons */}
        <button className="prev-btn" disabled>
          ❮
        </button>
        <button className="next-btn" disabled>
          ❯
        </button>
        {/* Pagination Dots */}
        <div className="dots">
          <span className="dot active"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </section>
  );
};

export default HeroSliderSkeleton;
